import { ModalState, Course } from './types';
import { createLogger, LogLevel } from '../utils/logger';

const logger = createLogger('CatalogModalsState', LogLevel.INFO);

const initialState: ModalState = {
  isOpen: false,
  currentModal: null,
  courseData: null,
};

let state: ModalState = { ...initialState };

const getState = (): ModalState => {
  logger.info('Получение состояния', state);
  return { ...state };
};

const dispatch = (action: { type: string; payload?: any }) => {
  logger.info('dispatch', action);
  switch (action.type) {
    case 'OPEN_MODAL':
      state.isOpen = true;
      state.currentModal = action.payload?.modalType || null;
      state.courseData = action.payload?.courseData || null;
      break;
    case 'CLOSE_MODAL':
      state.isOpen = false;
      state.currentModal = null;
      state.courseData = null;
      break;
    case 'SET_COURSE_DATA':
      state.courseData = action.payload;
      break;
    default:
      logger.warn('Неизвестный тип действия', action.type);
      break;
  }
  logger.info('Новое состояние', state);
};

export default {
  getState,
  dispatch,
}; 